import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/product_tab_active.png'
import _imports_1 from '@/assets/images/product_tab.png'
import _imports_2 from '@/assets/images/scheme_tab_active.png'
import _imports_3 from '@/assets/images/scheme_tab.png'
import _imports_4 from '@/assets/images/news_tab_active.png'
import _imports_5 from '@/assets/images/news_tab.png'
import _imports_6 from '@/assets/images/about_tab_active.png'
import _imports_7 from '@/assets/images/about_tab.png'


const _withScopeId = n => (_pushScopeId("data-v-172b3141"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-info" }
const _hoisted_2 = { class: "icon-container" }
const _hoisted_3 = {
  key: 0,
  class: "tab-icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  class: "tab-icon",
  src: _imports_1,
  alt: ""
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "产品中心", -1))
const _hoisted_6 = { class: "icon-container" }
const _hoisted_7 = {
  key: 0,
  class: "tab-icon",
  src: _imports_2,
  alt: ""
}
const _hoisted_8 = {
  key: 1,
  class: "tab-icon",
  src: _imports_3,
  alt: ""
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "产品方案", -1))
const _hoisted_10 = { class: "icon-container" }
const _hoisted_11 = {
  key: 0,
  class: "tab-icon",
  src: _imports_4,
  alt: ""
}
const _hoisted_12 = {
  key: 1,
  class: "tab-icon",
  src: _imports_5,
  alt: ""
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "最新动态", -1))
const _hoisted_14 = { class: "icon-container" }
const _hoisted_15 = {
  key: 0,
  class: "tab-icon",
  src: _imports_6,
  alt: ""
}
const _hoisted_16 = {
  key: 1,
  class: "tab-icon",
  src: _imports_7,
  alt: ""
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "关于我们", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["item", _ctx.activeIndex === 0 ? 'active' : '']),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleTab(0)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.activeIndex === 0)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : (_openBlock(), _createElementBlock("img", _hoisted_4))
      ]),
      _hoisted_5
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["item", _ctx.activeIndex === 1 ? 'active' : '']),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTab(1)))
    }, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.activeIndex === 1)
          ? (_openBlock(), _createElementBlock("img", _hoisted_7))
          : (_openBlock(), _createElementBlock("img", _hoisted_8))
      ]),
      _hoisted_9
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["item", _ctx.activeIndex === 2 ? 'active' : '']),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleTab(2)))
    }, [
      _createElementVNode("div", _hoisted_10, [
        (_ctx.activeIndex === 2)
          ? (_openBlock(), _createElementBlock("img", _hoisted_11))
          : (_openBlock(), _createElementBlock("img", _hoisted_12))
      ]),
      _hoisted_13
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["item", _ctx.activeIndex === 3 ? 'active' : '']),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleTab(3)))
    }, [
      _createElementVNode("div", _hoisted_14, [
        (_ctx.activeIndex === 3)
          ? (_openBlock(), _createElementBlock("img", _hoisted_15))
          : (_openBlock(), _createElementBlock("img", _hoisted_16))
      ]),
      _hoisted_17
    ], 2)
  ]))
}